var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 9,
    fill: "#F53838"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95878 11.2881C5.65957 11.5873 5.65957 12.0724 5.95878 12.3716C6.25798 12.6708 6.74308 12.6708 7.04228 12.3716L8.81364 10.6003L10.585 12.3716C10.8842 12.6708 11.3693 12.6708 11.6685 12.3716C11.9677 12.0724 11.9677 11.5873 11.6685 11.2881L9.89714 9.51677L11.6685 7.7454C11.9677 7.4462 11.9677 6.9611 11.6685 6.6619C11.3693 6.3627 10.8842 6.3627 10.585 6.6619L8.81364 8.43327L7.04228 6.6619C6.74308 6.3627 6.25798 6.3627 5.95878 6.6619C5.65958 6.9611 5.65958 7.4462 5.95878 7.7454L7.73014 9.51677L5.95878 11.2881Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/redCross.7c1f9ba2d0e85fe1fbcb8b07705e4115.svg";
export { ForwardRef as ReactComponent };